var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3754 8.91695C20.9248 10.6165 22.1994 11.4663 22.6436 12.5374C23.032 13.4738 23.032 14.5262 22.6436 15.4626C22.1994 16.5337 20.9248 17.3835 18.3754 19.0831L15.8615 20.7591C12.7761 22.8159 11.2335 23.8444 9.95426 23.768C8.83982 23.7014 7.81033 23.1505 7.13679 22.2601C6.36365 21.2381 6.36365 19.3841 6.36365 15.676L6.36365 12.324C6.36365 8.61597 6.36365 6.76193 7.13679 5.73991C7.81034 4.84956 8.83982 4.29859 9.95426 4.23205C11.2335 4.15567 12.7761 5.18411 15.8615 7.24098L18.3754 8.91695Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.ff8787211b2e21ff152d9857ae30a9b4.svg";
export { ForwardRef as ReactComponent };